import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { Button } from '@/components/ui/button';
import { useIsEditorReadonly } from '@/hooks/use-is-editor-readonly';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';
import { Plus } from 'lucide-react';
import { ITLAB_SECTION_ATTR, ITLAB_TAB } from './zyitlab-shared';

export function ZyITLabVmImagesNodeView({ editor, getPos, decorations }: ReactNodeViewProps) {
    const isEditorReadonly = useIsEditorReadonly(editor);
    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div
                className="mb-4 rounded border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-900/40"
                contentEditable={false}
                {...{ [ITLAB_SECTION_ATTR]: ITLAB_TAB.VM_IMAGES }}
            >
                <div className="mb-3 flex items-center justify-between">
                    <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200">VM images</h3>
                    <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        disabled={isEditorReadonly}
                        onClick={() => editor.commands.addZyITLabVmImage(getPos())}
                    >
                        <Plus className="mr-2 h-4 w-4" />
                        Add VM image
                    </Button>
                </div>
                <NodeViewContent />
            </div>
        </ZyNodeViewWrapper>
    );
}
